import styled from 'styled-components'

export const HrDashboardTitleLine = styled.div<{
  smallPaddingBottom?: boolean
  marginTop?: string
  overflow?: boolean
}>`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid #f5f5f520;
  ${(props) => props.smallPaddingBottom && 'padding-bottom: 0px;'}
  ${(props) => props.marginTop && `margin-top: ${props.marginTop};`}
  ${(props) => props.overflow && 'overflow: visible;'}
`
export const HrDashboardInnerWidgetContainer = styled.div<{ padding?: string; overflow?: boolean }>`
  display: flex;
  flex-direction: column;
  padding: ${(props) => props.padding || '0 8px'};
  overflow: ${(props) => (props.overflow ? 'visible' : 'hidden')};

  &:hover {
    overflow-y: auto; /* Only vertical */
    overflow-x: hidden; /* Disable horizontal */
  }

  @media (max-width: 1200px) {
    height: auto;
    overflow: unset;
  }

  & > div {
    .widget-notification {
      @media (max-width: 1200px) {
        flex-direction: column;
        align-items: start;
        gap: 5px;

        .time {
          color: #ff9900;
        }
      }
    }
  }
`
